import { useTranslation as useI18nTranslation } from 'react-i18next';

export function useTranslation() {
  const { t, i18n } = useI18nTranslation();

  const changeLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  const getCurrentLanguage = () => i18n.language;

  const isLanguage = (lang: string) => i18n.language === lang;

  return {
    t,
    i18n,
    changeLanguage,
    getCurrentLanguage,
    isLanguage,
  };
}
